import Nav from 'react-bootstrap/Nav'
import './navbar.scss'
import { useHistory } from 'react-router-dom'
import api_host from '../../env'
import React, { useState } from 'react'
import ModalBS from '../../components/modal/modal'

function Navbar() {
  const history = useHistory()
  const [confirmModal, setConfirmModal] = useState(false)
  const handleModalClose = () => setConfirmModal(false)

  const logout = () => {
    fetch(`${api_host}/signout`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.status == 'OK') {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else {
          sessionStorage.removeItem('token')
          history.push('/signin')
        }
      })
  }
  const isLoggedIn = sessionStorage.getItem('token')
  return (
    <>
      <Nav
        activeKey="/home"
        className="navbar-csio"
      >
        {isLoggedIn && (
          <Nav.Item>
            <Nav.Link onClick={() => setConfirmModal(true)}>Logout</Nav.Link>
          </Nav.Item>
        )}
      </Nav>
      <ModalBS
        show={confirmModal}
        handleClose={handleModalClose}
        modalHeader={<>Warning!</>}
        modalBody={<p>Are you sure you want to Sign out?</p>}
        modalFooter={
          <>
            <button
              className="primary-btn modal-btn"
              onClick={handleModalClose}
            >
              No
            </button>
            <button
              className="primary-btn modal-btn"
              onClick={() => {
                handleModalClose()
                logout()
              }}
            >
              Yes
            </button>
          </>
        }
      ></ModalBS>
    </>
  )
}

export default Navbar
